import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VForm,
    {
      ref: "form",
      attrs: {
        "lazy-validation": "",
        readonly: !_vm.edit,
        "aria-disabled": _vm.edit,
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        VStepper,
        {
          model: {
            value: _vm.e1,
            callback: function ($$v) {
              _vm.e1 = $$v
            },
            expression: "e1",
          },
        },
        [
          _c(
            VStepperHeader,
            [
              _c(
                VStepperStep,
                { attrs: { complete: _vm.e1 > 1, step: "1" } },
                [_vm._v(" Seleccione un caso de uso ")]
              ),
              _c(VDivider),
              _c(
                VStepperStep,
                { attrs: { complete: _vm.e1 > 2, step: "2" } },
                [_vm._v(" Listado de tablas ")]
              ),
              _c(VDivider),
              _c(
                VStepperStep,
                { attrs: { complete: _vm.e1 > 3, step: "3" } },
                [_vm._v(" Estadísticos de los campos a exportar ")]
              ),
            ],
            1
          ),
          _c(
            VStepperItems,
            [
              _c(
                VStepperContent,
                { attrs: { step: "1" } },
                [
                  _c(
                    VRow,
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "form_attrs_productize_usecase.use_case"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "8" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      outlined: _vm.edit,
                                      filled: !_vm.edit,
                                      "hide-details": "auto",
                                      dense: "",
                                      items: _vm.items,
                                      "item-text": "business_name",
                                      "return-object": "",
                                      required: "",
                                      rules: _vm.rules.selected_use_case,
                                      disabled: _vm.editFile,
                                    },
                                    on: {
                                      change: _vm.triggerSegmentValidation,
                                    },
                                    model: {
                                      value: _vm.form.selected_use_case,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "selected_use_case",
                                          $$v
                                        )
                                      },
                                      expression: "form.selected_use_case",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "form_attrs_productize_usecase.table_name"
                                          )
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "8" } },
                                [
                                  _c(VTextField, {
                                    ref: "segmentField",
                                    staticClass: "pl-0 pl-md-0",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      name: "form.segment",
                                      required: "",
                                      rules: [
                                        _vm.rules.segment,
                                        _vm.rules.max_length,
                                        _vm.rules.min_length,
                                        _vm.rules.segment_format,
                                        _vm.rules.not_in_forbidden,
                                        _vm.segmentValidation,
                                      ],
                                      autocomplete: "off",
                                      disabled: _vm.editFile,
                                    },
                                    on: { blur: _vm.onSegmentChange },
                                    model: {
                                      value: _vm.form.segment,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "segment", $$v)
                                      },
                                      expression: "form.segment",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "form_attrs_productize_usecase.destination_scheme"
                                          )
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "8" } },
                                [
                                  _vm.companyCode === "000"
                                    ? _c(VTextField, {
                                        staticClass: "pl-0 pl-md-0",
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          name: "form.destination_table_id",
                                          required: "",
                                          rules: _vm.rules.destination_scheme,
                                          autocomplete: "off",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.form.destination_scheme,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "destination_scheme",
                                              $$v
                                            )
                                          },
                                          expression: "form.destination_scheme",
                                        },
                                      })
                                    : _c(VTextField, {
                                        staticClass: "pl-0 pl-md-0",
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          name: "form.destination_table_id",
                                          required: "",
                                          rules: _vm.rules.destination_scheme,
                                          autocomplete: "off",
                                          disabled: _vm.editFile,
                                        },
                                        model: {
                                          value: _vm.form.destination_scheme,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "destination_scheme",
                                              $$v
                                            )
                                          },
                                          expression: "form.destination_scheme",
                                        },
                                      }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "form_attrs_productize_usecase.model"
                                          )
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "8" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      required: "",
                                      rules: _vm.rules.model,
                                      disabled:
                                        _vm.editFile &&
                                        !_vm.modelInitiallyEmpty,
                                    },
                                    model: {
                                      value: _vm.form.model,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "model", $$v)
                                      },
                                      expression: "form.model",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "form_attrs_productize_usecase.type_export"
                                          )
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "8" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      outlined: _vm.edit,
                                      filled: !_vm.edit,
                                      "hide-details": "auto",
                                      dense: "",
                                      items: _vm.type_export_items,
                                      "item-text": "export_type_name",
                                      "return-object": "",
                                      rules: _vm.rules.type_export,
                                      required: "",
                                      disabled: _vm.editFile,
                                    },
                                    on: {
                                      change: _vm.triggerSegmentValidation,
                                    },
                                    model: {
                                      value: _vm.form.type_export,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "type_export", $$v)
                                      },
                                      expression: "form.type_export",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Tipo de transformación: ")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "8" } },
                                [
                                  _c(VSelect, {
                                    staticClass: "mb-2",
                                    attrs: {
                                      label: "Seleccione una opción",
                                      outlined: "",
                                      dense: "",
                                      filled: !_vm.edit,
                                      items: _vm.form.transformation_types,
                                      "hide-details": "auto",
                                      disabled: _vm.editFile,
                                    },
                                    on: { change: _vm.emitTransformationType },
                                    model: {
                                      value: _vm.form.transformation_type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "transformation_type",
                                          $$v
                                        )
                                      },
                                      expression: "form.transformation_type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.form.type_export &&
                                              (_vm.form.type_export.id == 2 ||
                                                _vm.form.type_export.id == 3)
                                              ? "form_attrs_productize_usecase.description_table"
                                              : _vm.form.type_export &&
                                                _vm.form.type_export.id == 1
                                              ? "form_attrs_productize_usecase.description_segment"
                                              : "form_attrs_productize_usecase.description"
                                          )
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "8" } },
                                [
                                  _c(VTextarea, {
                                    staticClass: "pl-0 pl-md-0",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      name: "textarea",
                                      rules: _vm.rules.description,
                                      required: "",
                                      rows: "2",
                                      disabled: _vm.editFile,
                                    },
                                    model: {
                                      value: _vm.form.description,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "description", $$v)
                                      },
                                      expression: "form.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.form.transformation_type !== "Binning"
                        ? _c(
                            VCard,
                            {
                              staticClass:
                                "min-w-0 w-full card-bulk pt-2 pb-0 mb-0",
                            },
                            [
                              _c(
                                VCol,
                                {
                                  staticClass: "text-center mb-2",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        dragover: function ($event) {
                                          $event.preventDefault()
                                        },
                                        drop: function ($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "drag-file text-center pt-1 mt-1 pointer",
                                          on: { drop: _vm.dropFile },
                                        },
                                        [
                                          !_vm.hasFile
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column justify-space-between align-center",
                                                },
                                                [
                                                  _c(VImg, {
                                                    attrs: {
                                                      width: "64px",
                                                      src: require("@/assets/sql_icon.png"),
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          !_vm.hasFile
                                            ? _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "customer_insights.bulk_upload.drag_here"
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                          _c(VFileInput, {
                                            key: _vm.keyPrevisualize,
                                            staticClass:
                                              "upload-input-file pointer",
                                            attrs: {
                                              rules: _vm.rules.file,
                                              accept: ".py",
                                              chips: "",
                                              placeholder: _vm.$t(
                                                "form_attrs_productize_usecase.attach_file"
                                              ),
                                              "prepend-icon": "",
                                              "show-size": "",
                                              "truncate-length": "35",
                                              solo: "",
                                              flat: "",
                                            },
                                            on: { change: _vm.onFileSelected },
                                            model: {
                                              value: _vm.form.py_file,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "py_file",
                                                  $$v
                                                )
                                              },
                                              expression: "form.py_file",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _vm.form.type_export &&
                                  _vm.form.type_export.id == 4
                                    ? _c(
                                        VAlert,
                                        {
                                          staticClass: "transparent-bg",
                                          attrs: {
                                            type: "info",
                                            variant: "outlined",
                                            text: "text",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Pasará por un flujo de aprobación. "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VStepperContent,
                { attrs: { step: "2" } },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "6" } },
                        [
                          _vm.isBinning
                            ? _c(VTextField, {
                                ref: "search",
                                staticClass: "mx-1 hidden-xs-only",
                                attrs: {
                                  "prepend-inner-icon": "icon-search",
                                  "hide-details": "",
                                  filled: "",
                                  rounded: "",
                                  dense: "",
                                },
                                on: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.sendToSearch($event)
                                  },
                                },
                                model: {
                                  value: _vm.searchQuery,
                                  callback: function ($$v) {
                                    _vm.searchQuery = $$v
                                  },
                                  expression: "searchQuery",
                                },
                              })
                            : _vm._e(),
                          !_vm.isBinning
                            ? _c(VTextField, {
                                staticClass: "mt-1",
                                attrs: {
                                  label: "Filtrar atributos",
                                  clearable: "",
                                  dense: "",
                                  "append-icon": "mdi-magnify",
                                  outlined: "",
                                },
                                model: {
                                  value: _vm.searchQuery,
                                  callback: function ($$v) {
                                    _vm.searchQuery = $$v
                                  },
                                  expression: "searchQuery",
                                },
                              })
                            : _vm._e(),
                          _c(VDataTable, {
                            key: _vm.keyTable,
                            staticClass: "text-center table-inca",
                            attrs: {
                              disabled: _vm.isLoading,
                              headers: _vm.headers,
                              items: _vm.filteredItems,
                              "item-key": "id",
                              "group-by": "attribute_category",
                              "hide-default-footer": "",
                              "items-per-page": _vm.pagination.limit,
                              loading: _vm.isLoading,
                              page: _vm.pagination.current,
                              responsive: "",
                              "show-select": "",
                              "item-class": _vm.isBinning ? _vm.rowClass : null,
                            },
                            on: {
                              pagination: function ($event) {
                                _vm.pagination.total = $event.itemsLength
                              },
                              "update:page": function ($event) {
                                return _vm.$set(
                                  _vm.pagination,
                                  "current",
                                  $event
                                )
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "group.header",
                                fn: function (ref) {
                                  var group = ref.group
                                  return [
                                    _c("td", { attrs: { colspan: "4" } }, [
                                      _c("strong", [_vm._v(_vm._s(group))]),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.data-table-select",
                                fn: function (ref) {
                                  var item = ref.item
                                  var isSelected = ref.isSelected
                                  var select = ref.select
                                  return [
                                    _c(VSimpleCheckbox, {
                                      attrs: {
                                        value: isSelected,
                                        disabled: _vm.isBinning
                                          ? (!isSelected &&
                                              _vm.internalSelected.length >=
                                                _vm.maxAttributes) ||
                                            !_vm.canSelectItem(item)
                                          : false,
                                      },
                                      on: {
                                        input: function ($event) {
                                          return select(!isSelected)
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.internalSelected,
                              callback: function ($$v) {
                                _vm.internalSelected = $$v
                              },
                              expression: "internalSelected",
                            },
                          }),
                          _c("pagination-vue", {
                            attrs: { pagination: _vm.pagination },
                          }),
                          !_vm.isValidAttributes
                            ? _c("p", { staticClass: "error--text" }, [
                                _vm._v(
                                  "Debes seleccionar al menos un atributo."
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "caption grey--text mt-1" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.internalSelected.length) +
                                  " / " +
                                  _vm._s(_vm.maxAttributes) +
                                  " seleccionados "
                              ),
                            ]
                          ),
                          _vm.attrMessage
                            ? _c(
                                VAlert,
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    type: _vm.attrError ? "error" : "info",
                                    dense: "",
                                    outlined: "",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.attrMessage) + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "6" } },
                        [
                          _c("div", { staticClass: "mb-2 font-weight-bold" }, [
                            _vm._v("Periodo(s):"),
                          ]),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4", sm: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      label: "Mes",
                                      items: _vm.months,
                                      "item-text": "name",
                                      "item-value": "value",
                                      outlined: "",
                                      "hide-details": "auto",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.selectedMonth,
                                      callback: function ($$v) {
                                        _vm.selectedMonth = $$v
                                      },
                                      expression: "selectedMonth",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4", sm: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      label: "Año",
                                      items: _vm.years,
                                      "item-text": "name",
                                      "item-value": "value",
                                      outlined: "",
                                      "hide-details": "auto",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.selectedYear,
                                      callback: function ($$v) {
                                        _vm.selectedYear = $$v
                                      },
                                      expression: "selectedYear",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4", sm: "4" } },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        color: "primary",
                                        disabled:
                                          _vm.chips.length >= _vm.maxChips,
                                      },
                                      on: { click: _vm.addChip },
                                    },
                                    [_vm._v("Agregar")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    VChipGroup,
                                    { attrs: { column: "" } },
                                    _vm._l(_vm.chips, function (chip, index) {
                                      return _c(
                                        VChip,
                                        {
                                          key: chip.id,
                                          staticClass: "caption small m-1",
                                          attrs: {
                                            color: "primary",
                                            close: "",
                                          },
                                          on: {
                                            "click:close": function ($event) {
                                              return _vm.removeChip(index)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(chip.display) + " "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                  !_vm.isValidChips
                                    ? _c("p", { staticClass: "error--text" }, [
                                        _vm._v(
                                          "Debes seleccionar al menos un periodo."
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          this.form.transformation_type == "Binning"
                            ? _c(
                                VRow,
                                { staticClass: "mt-4" },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-2 font-weight-bold",
                                        },
                                        [_vm._v("Atributos seleccionados:")]
                                      ),
                                      _vm.selectedItems.length
                                        ? [
                                            _c("value-range-config", {
                                              attrs: {
                                                "from-selection":
                                                  _vm.selectedItems,
                                                "title-key": "attribute_name",
                                                "id-key": "id",
                                                "int-rule": _vm.rules.value_int,
                                                "gap-rule":
                                                  _vm.rules.value_gap_min(
                                                    _vm.minGap
                                                  ),
                                              },
                                              on: {
                                                "remove-from-selection":
                                                  _vm.onRemoveFromRange,
                                              },
                                              model: {
                                                value: _vm.rangeSections,
                                                callback: function ($$v) {
                                                  _vm.rangeSections = $$v
                                                },
                                                expression: "rangeSections",
                                              },
                                            }),
                                          ]
                                        : _c(
                                            "p",
                                            {
                                              staticClass: "caption grey--text",
                                            },
                                            [
                                              _vm._v(
                                                "No hay atributos seleccionados."
                                              ),
                                            ]
                                          ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.form.has_pls
                            ? _c(
                                VRow,
                                [
                                  _vm._v(" Pesos: "),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          staticClass:
                                            "ml-1 btn-inca-secondary",
                                          attrs: { dense: "", outlined: "" },
                                          on: { click: _vm.addGroup },
                                        },
                                        [_vm._v(" Agregar componente ")]
                                      ),
                                      _c(VTreeview, {
                                        staticClass: "my-treeview",
                                        attrs: {
                                          items: _vm.groups,
                                          "open-all": "",
                                          activatable: "",
                                          "item-key": "id",
                                          density: "compact",
                                          open: _vm.open,
                                        },
                                        on: {
                                          "update:open": function ($event) {
                                            _vm.open = $event
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prepend",
                                              fn: function (ref) {
                                                var item = ref.item
                                                var open = ref.open
                                                return [
                                                  item.type === "group"
                                                    ? _c(
                                                        VRow,
                                                        {
                                                          staticClass: "mt-1",
                                                          attrs: {
                                                            "no-gutters": "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "11",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VTextField,
                                                                {
                                                                  attrs: {
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    rules:
                                                                      _vm.rules
                                                                        .campo,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.comp,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "comp",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.comp",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            VCol,
                                                            {
                                                              staticClass:
                                                                "mt-1",
                                                              attrs: {
                                                                cols: "1",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VIcon,
                                                                {
                                                                  attrs: {
                                                                    right: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.removeGroup(
                                                                          item.id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "icon-remove"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        VRow,
                                                        {
                                                          attrs: {
                                                            "no-gutters": "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VAutocomplete,
                                                                {
                                                                  attrs: {
                                                                    items:
                                                                      _vm.attributes_array,
                                                                    label:
                                                                      "Atributo",
                                                                    outlined:
                                                                      "",
                                                                    "hide-details":
                                                                      "auto",
                                                                    rules:
                                                                      _vm.rules
                                                                        .campo,
                                                                    dense: "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.atributo,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "atributo",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.atributo",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            VCol,
                                                            {
                                                              staticClass:
                                                                "pl-1",
                                                              attrs: {
                                                                cols: "3",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VTextField,
                                                                {
                                                                  attrs: {
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    label:
                                                                      "Peso",
                                                                    type: "number",
                                                                    rules:
                                                                      _vm.rules
                                                                        .campo,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.peso,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "peso",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.peso",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            VCol,
                                                            {
                                                              staticClass:
                                                                "mt-1",
                                                              attrs: {
                                                                cols: "3",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VIcon,
                                                                {
                                                                  attrs: {
                                                                    right: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.removeChild(
                                                                          item.id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "icon-remove"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm.isLastChild(
                                                                item
                                                              )
                                                                ? _c(
                                                                    VIcon,
                                                                    {
                                                                      attrs: {
                                                                        right:
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.addChild(
                                                                              item.groupId
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "icon-add"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1910959263
                                        ),
                                      }),
                                      !_vm.isValidTree
                                        ? _c(
                                            "p",
                                            { staticClass: "error--text" },
                                            [
                                              _vm._v(
                                                "Cada componente debe tener al menos 2 atributos."
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _vm.flag_alert
                            ? _c(
                                VAlert,
                                {
                                  staticClass: "transparent-bg",
                                  attrs: {
                                    type: "info",
                                    variant: "outlined",
                                    text: "text",
                                  },
                                },
                                [
                                  _vm._v(
                                    " No se tiene acceso a todas las tablas INCA. Cuando se realicen todas las aprobaciones podrá ejecutar el proceso. "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VStepperContent,
                { attrs: { step: "3" } },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VDataTable, {
                            staticClass: "text-center table-inca",
                            attrs: {
                              headers: _vm.headersStats,
                              items: _vm.statisticsFields,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.periodo",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.periodo != null &&
                                            item.periodo !== ""
                                            ? item.periodo
                                            : "—"
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.atributo",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.atributo != null &&
                                            item.atributo !== ""
                                            ? item.atributo
                                            : "—"
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.cantidad",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "div",
                                      {
                                        class: _vm.cellClassNum(item.cantidad),
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatNum(item.cantidad))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.promedio",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "div",
                                      {
                                        class: _vm.cellClassNum(item.promedio),
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatNum(item.promedio))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.std",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "div",
                                      { class: _vm.cellClassNum(item.std) },
                                      [_vm._v(_vm._s(_vm.formatNum(item.std)))]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.minimo",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "div",
                                      { class: _vm.cellClassNum(item.minimo) },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatNum(item.minimo))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.maximo",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "div",
                                      { class: _vm.cellClassNum(item.maximo) },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatNum(item.maximo))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("segment-tables-component", {
        ref: "tablesComponent",
        attrs: { "is-productivize": true, "productivize-info": _vm.form },
      }),
      _c("dialog-confirmation-component", {
        ref: "confirm",
        attrs: {
          title: "Confirmación",
          text: "Hay atributos con valores en cero. ¿Desea continuar?",
          si_text: "Sí",
          no_text: "No",
        },
        on: { onConfirm: _vm.handleConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }